const { Button } = require("reactstrap");

function nozzleColumns(handleEdit, handleDelete, isAdmin) {
  return [
    {
      Header: "Nozzle Number",
      accessor: "nozzel_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Vehicle Number",
      accessor: "vehicle_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Total Capacity (Ltr)", 
      accessor: "total_capacity",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Remaining Capacity (Ltr)", 
      accessor: "remaining_capacity",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
      <span
        className={`badge ${
          value ? "bg-success" : "bg-warning"
        }`}
      >
        {value ? "Active" : "Inactive"}
      </span>
    )
    },
    {
      Header: "Notes",
      accessor: "notes",
      disableFilters: true,
      filterable: false,
    },
    ...(isAdmin && (handleEdit || handleDelete)
      ? [
    {
      Header: "Actions",
      accessor: "actions",
      disableFilters: true,
      filterable: false,
      
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
            {handleEdit && (
              <button onClick={() => handleEdit(row.original)} className="btn btn-sm btn-primary">Edit</button>
            )}
            {handleDelete && (
              <button onClick={() => handleDelete(row.original)} className="btn btn-sm btn-danger">Delete</button>
            )}
          </div>
      )
    },
      ]
      : []),
  ];
}

export default nozzleColumns;